import {
  Stethoscope,
  Sparkles,
  Droplets,
  ShieldCheck,
  GraduationCap,
  ClipboardList,
  Bandage,
  HeartPulse,
} from "lucide-react";

export const services = [
  {
    slug: "check-ups",
    icon: Stethoscope,
    title: "Dental check-ups",
    short:
      "A gentle, thorough oral examination to spot issues early and support long-term dental health.",
    long:
      "Our clinicians conduct a comprehensive visual examination of your child's teeth, gums, bite and oral tissues. We take the time to explain what we see, answer questions and provide clear next steps.",
    accent: "#1677C8",
  },
  {
    slug: "professional-cleans",
    icon: Sparkles,
    title: "Professional cleans",
    short: "Careful removal of plaque and stains to leave teeth feeling clean and fresh.",
    long:
      "Where clinically appropriate, we provide age-appropriate scale-and-polish treatments to remove plaque build-up and surface stains, and to reinforce healthy brushing habits.",
    accent: "#23B7C5",
  },
  {
    slug: "fluoride",
    icon: Droplets,
    title: "Fluoride treatments",
    short: "Preventive fluoride applications to help strengthen enamel against decay.",
    long:
      "Topical fluoride treatments are quick and comfortable, and can help protect developing teeth from decay, particularly for children at higher risk.",
    accent: "#1677C8",
  },
  {
    slug: "fissure-sealants",
    icon: ShieldCheck,
    title: "Fissure sealants",
    short: "A protective coating for back teeth to help prevent decay in deep grooves.",
    long:
      "Fissure sealants are a thin protective coating painted onto the chewing surfaces of molars to help prevent decay in areas where a toothbrush may struggle to reach.",
    accent: "#FFD45C",
  },
  {
    slug: "oral-health-education",
    icon: GraduationCap,
    title: "Oral health education",
    short: "Fun, age-appropriate lessons on brushing, diet and looking after growing smiles.",
    long:
      "We deliver simple, engaging oral-health talks and one-on-one guidance, empowering students to take ownership of their dental care and build lifelong habits.",
    accent: "#23B7C5",
  },
  {
    slug: "treatment-referrals",
    icon: ClipboardList,
    title: "Treatment planning & referrals",
    short: "Clear reports for parents and warm referrals when further care is needed.",
    long:
      "After each visit we provide families with a plain-English summary and, where further treatment is recommended, we help connect them with an appropriate local dental provider.",
    accent: "#1677C8",
  },
  {
    slug: "dental-fillings",
    icon: Bandage,
    title: "Dental fillings",
    short:
      "Restoring decayed teeth with tooth-coloured fillings, where clinically appropriate and consented.",
    long:
      "Where a cavity is identified during examination and can be safely treated in the mobile clinic setting, we provide simple, tooth-coloured restorations. More complex restorative work is referred to a suitable local dental provider. All fillings are only performed with informed consent from a parent or guardian.",
    accent: "#23B7C5",
  },
  {
    slug: "gum-disease-treatment",
    icon: HeartPulse,
    title: "Gum disease treatment",
    short:
      "Early identification and gentle management of gum inflammation to protect long-term oral health.",
    long:
      "Our clinicians check the health of your child's gums at every visit. Where early signs of gingivitis or gum inflammation are found, we provide gentle cleaning, tailored home-care advice and, if needed, referral for further periodontal care. Treatment offered on the day depends on clinical assessment and consent.",
    accent: "#FFD45C",
  },
];
